module.exports = __webpack_public_path__ + "static/media/mt.3c1b84c9.svg";